// extracted by mini-css-extract-plugin
module.exports = {"detailRateModal":"f7","rateHeaderRow":"f8","closeIcon":"f9","closeIconWrapper":"f-","rateText":"f_","rateOptionsRow":"ha"};